import axios from "axios";
export const getSchools = () => {
  return (dispatch) => {
    var token = localStorage.getItem("token");
    var config = {
      method: "get",
      url: "https://api.shuribusapp.com/api/v1/schools?page=1&limit=5&search=",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    axios(config)
      .then((response) => {
        console.log(response.data.data.schools);

        dispatch({
          type: "GET SCHOOLS SUCCESS",
          payload: response.data.data.schools,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };
};
export const saveSchool = (school) => {
  return (dispatch) => {
    var token = localStorage.getItem("token");

    var data = JSON.stringify({
      name: school.Schoolname,
      email: school.Schoolemail,
      district: school.Schooldistrict,
      sector: school.Schooldistrict,
      cell: school.Schoolcell,
      country: school.Schoolcountry,
      phoneNumber: school.Schoolphone,
      latitude: school.Schoollat,
      longitude: school.Schoollog,
      location: school.Schoollocation,
    });

    var config = {
      method: "post",
      url: "https://api.shuribusapp.com/api/v1/schools",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data,
    };

    axios(config)
      .then((response) => {
        // dispatch(getSchool());
      })
      .catch((error) => {
        dispatch({ type: "error", payload: error });
        console.log(error);
      });
  };
};
